import { render, staticRenderFns } from "./MaterialDonationView.vue?vue&type=template&id=31c93c11&"
import script from "./MaterialDonationView.vue?vue&type=script&lang=js&"
export * from "./MaterialDonationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports